import { IEntitiesResponse, TEntity } from "models/entities.models";
import { QueryAPIKey } from "utils/constants/api.constants";
import queries from "../../queries";

export const entitiesQueryConfig = {
  getEntities: {
    query: queries.entity.getEntities,
    queryKey: [QueryAPIKey.GetEntities],
    errorMessageKey: "getEntitiesFailure",
    queryOptions: {
      select: (data: IEntitiesResponse): TEntity[] => data.entities ?? [],
    },
  },
};
